'use client';

import { Heading, Button } from '@/components/ui'

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Capture error to Sentry
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-md rounded-lg bg-surface p-8 shadow-lg">
        <div className="mb-4 flex items-center">
          <svg
            className="h-6 w-6 text-danger"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <Heading level={2} className="ml-3 text-ink-strong">
            Something went wrong
          </Heading>
        </div>

        <p className="mb-6 text-sm text-muted">
          We&apos;ve been notified and are working to fix the issue. Please try again.
        </p>

        {process.env.NODE_ENV === 'development' && (
          <div className="mb-6 rounded border border-danger-subtle bg-danger-subtle p-3">
            <p className="text-xs font-mono text-danger">
              {error.message}
            </p>
          </div>
        )}

        <div className="flex gap-3">
          <Button variant="primary"
            onClick={reset}
            className="flex-1 text-on-accent"
          >
            Try again
          </Button>
          <Button variant="secondary"
            onClick={() => window.location.href = '/'}
            className="flex-1 text-center"
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
}
